import { Months, SsNumberFirstValues } from '../global';
import { IsNullOrEmpty } from '../utils/str.helper';
/**
 * 31 correspond à Janvier et 42 à décembre
 */
const PseudoMonths = Array.from(new Array(12), (x, i) => `${i + 31}`);
/**
 * Toutes ces valeurs (20 à 30 et 50 à 99) sont autorisées pour le mois de naissance et ne permettent pas de contrôle de cohérence.
 */
const FictifMonths = Array.from(new Array(10), (x, i) => `${i + 20}`).concat(Array.from(new Array(50), (x, i) => `${i + 50}`));
export var NUMERO_SECU_ERROR_MESSAGE;
(function (NUMERO_SECU_ERROR_MESSAGE) {
    NUMERO_SECU_ERROR_MESSAGE["INVALID_FIRST_CHAR"] = "Le 1er chiffre du n\u00B0 de s\u00E9curit\u00E9 sociale est erron\u00E9. Il doit \u00EAtre compris entre 1 et 4 ou entre 7 et 8";
    NUMERO_SECU_ERROR_MESSAGE["INVALID_MONTH"] = "Les 4\u00E8me et 5\u00E8me chiffres sont incorrects, ils doivent correspondre \u00E0 votre mois de naissance";
    NUMERO_SECU_ERROR_MESSAGE["INCOMPLETE"] = "Le n\u00B0 de s\u00E9curit\u00E9 sociale est incomplet, il doit comporter 15 chiffres";
    NUMERO_SECU_ERROR_MESSAGE["INVALID"] = "Le num\u00E9ro de s\u00E9curit\u00E9 sociale n\u2019est pas valide";
    NUMERO_SECU_ERROR_MESSAGE["YEAR_MISMATCH"] = "L'ann\u00E9e saisie ne correspond pas au num\u00E9ro de s\u00E9curit\u00E9 sociale";
    NUMERO_SECU_ERROR_MESSAGE["MONTH_MISMATCH"] = "Le mois saisi ne correspond pas au num\u00E9ro de s\u00E9curit\u00E9 sociale";
})(NUMERO_SECU_ERROR_MESSAGE || (NUMERO_SECU_ERROR_MESSAGE = {}));
export const ssNumber = (value) => {
    const str = value.replace(/\s/g, '');
    const firstChar = str[0];
    if (SsNumberFirstValues.indexOf(firstChar) < 0) {
        return NUMERO_SECU_ERROR_MESSAGE.INVALID_FIRST_CHAR;
    }
    const month = str[3] + str[4];
    if (Months.indexOf(month) < 0 &&
        PseudoMonths.indexOf(month) < 0 &&
        FictifMonths.indexOf(month) < 0) {
        return NUMERO_SECU_ERROR_MESSAGE.INVALID_MONTH;
    }
    if (str.length !== 15) {
        return NUMERO_SECU_ERROR_MESSAGE.INCOMPLETE;
    }
    const key = str[13] + str[14];
    let nir = '';
    const numberedNumSecu = str
        .toUpperCase()
        .replace('2A', '19')
        .replace('2B', '18');
    for (let index = 0; index < 13; index++) {
        nir += numberedNumSecu[index];
    }
    if (97 - (parseInt(nir) % 97) !== parseInt(key)) {
        return NUMERO_SECU_ERROR_MESSAGE.INVALID;
    }
    return true;
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const birthdayFromSN = (date, args) => {
    const str = args[0].replace(/\s/g, '');
    const temp = date.split('-');
    const snYear = str[1] + str[2];
    let snMonth = str[3] + str[4];
    const birthdayYear = temp[0];
    const minBirthdayYear = birthdayYear[2] + birthdayYear[3];
    const birthdayMonth = temp[1];
    if (snYear !== minBirthdayYear) {
        return NUMERO_SECU_ERROR_MESSAGE.YEAR_MISMATCH;
    }
    if (FictifMonths.indexOf(snMonth) < 0) {
        if (PseudoMonths.indexOf(snMonth) >= 0) {
            snMonth = `${parseInt(snMonth) - 30}`.padStart(2, '0');
        }
        if (snMonth !== birthdayMonth) {
            return NUMERO_SECU_ERROR_MESSAGE.MONTH_MISMATCH;
        }
    }
    return true;
};
export const isValidOrganismForNoemie = (organism) => {
    if (IsNullOrEmpty(organism))
        return false;
    const trimmedOrganism = organism.split(' ').join('');
    if (trimmedOrganism.length !== 9)
        return false;
    const firstDigits = trimmedOrganism[0] + trimmedOrganism[1];
    // les numéros d'organisme commençant par 12, 14, 15, 17 ne sont pas noemisables
    if (firstDigits === '12' || firstDigits === '14' || firstDigits === '15' || firstDigits === '17')
        return false;
    return true;
};
